export default "__VITE_ASSET__a748049b__"